import { Component, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { environment } from 'src/environments/environment';

import {MatPaginator} from '@angular/material/paginator';
import {MatTableDataSource} from '@angular/material/table';

@Component({
  selector: 'app-design-system',
  templateUrl: './design-system.component.html',
  styleUrls: ['./design-system.component.css']
})
export class DesignSystemComponent {
  displayedColumns: string[] = ['position', 'name', 'weight', 'symbol'];
  dataSource = new MatTableDataSource<PeriodicElement>(ELEMENT_DATA);

  @ViewChild(MatPaginator) paginator: MatPaginator | any = {};

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
  }


  imagePath:any=environment.image_path;

  components = [
    { value: 'all-components', viewValue: 'All' },
    { value: 'mechanical-components', viewValue: 'Mechanical' },
    { value: 'electronics-components', viewValue: 'Electronics' }
  ];

  projectForm!: FormGroup;
  testingForm!: FormGroup;
  startDate = new Date(1990, 0, 1);

  constructor(private fb: FormBuilder) {
    this.projectForm = this.fb.group({
      default: [''],
      active: [''],
      disabled: [{value: '', disabled: true}],
      error: ['', Validators.required]
    });

    this.testingForm = this.fb.group({
      default: [''],
      active: [''],
      disabled: [{value: '', disabled: true}],
      error: ['', Validators.required]
    });
  }

  markAsTouched() {
    this.projectForm.get('error')?.markAsTouched();
    this.testingForm.get('error')?.markAsTouched();
  }

  ngOnInit(): void {
    
    this.testingForm = new FormGroup({
      testing: new FormControl("",[Validators.required]),
      
    });

    
  }  

  task = {
    name: 'Indeterminate',
    completed: false,
    color: 'primary',
    subtasks: [
      {name: 'Primary', completed: false, color: 'primary'},
      // {name: 'Accent', completed: false, color: 'accent'},
      // {name: 'Warn', completed: false, color: 'warn'},
    ],
  };

  allComplete: boolean = false;

  updateAllComplete() {
    this.allComplete = this.task.subtasks != null && this.task.subtasks.every(t => t.completed);
  }

  someComplete(): boolean {
    if (this.task.subtasks == null) {
      return false;
    }
    return this.task.subtasks.filter(t => t.completed).length > 0 && !this.allComplete;
  }

  setAll(completed: boolean) {
    this.allComplete = completed;
    if (this.task.subtasks == null) {
      return;
    }
    this.task.subtasks.forEach(t => (t.completed = completed));
  }

  hasError(form: FormGroup,controlName: string, errorName: string): boolean {
    const control = form.get(controlName);
    return !!control?.hasError(errorName) && (!!control?.touched);
  }
}
export interface PeriodicElement {
  name: string;
  position: number;
  weight: number;
  symbol: string;
}

const ELEMENT_DATA: PeriodicElement[] = [
  {position: 1, name: 'Hydrogen', weight: 1.0079, symbol: 'H'},
  {position: 2, name: 'Helium', weight: 4.0026, symbol: 'He'},
  {position: 3, name: 'Lithium', weight: 6.941, symbol: 'Li'},
];